var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTagNewSquare = function SvgTagNewSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 3.563V3a1 1 0 0 0-1-1h-11a1 1 0 0 0-1 1v.563M.5 10.438V11a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-.562M7.66 5.469H5.82V8.53h1.84M5.82 6.872h1.61M2.028 8.531V5.47L4.07 8.53V5.47M8.91 5.469l.487 2.926a.164.164 0 0 0 .161.136v0c.07 0 .132-.044.155-.11l.643-1.871a.09.09 0 0 1 .085-.06v0a.09.09 0 0 1 .084.06l.643 1.87c.023.067.085.111.155.111v0c.08 0 .148-.058.161-.136l.488-2.926"
  }))));
};
export default SvgTagNewSquare;